var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoDarkBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 183.8 183.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #12174d;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 91.9,
    cy: 91.9,
    r: 91.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.9,34.5l72.4,72.4c3.4,3.4,3.4,9,0,12.4h0c-3.4,3.4-9,3.4-12.4,0L64.6,46.9c-3.4-3.4-3.4-9,0-12.4h0c3.4-3.4,8.9-3.4,12.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.3,80.3l30.3,30.3c3.4,3.4,3.4,9,0,12.4h0c-3.4,3.4-9,3.4-12.4,0l-30.3-30.3c-3.4-3.4-3.4-9,0-12.4h0c3.4-3.4,9-3.4,12.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.3,119.6h0c3.4,3.4,3.4,8.9,0,12.3l-.1,.1c-3.4,3.4-8.9,3.4-12.3,0h0c-3.4-3.4-3.4-8.9,0-12.3l.1-.1c3.4-3.4,8.9-3.4,12.3,0Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDarkBlue);
export default __webpack_public_path__ + "static/media/logoDarkBlue.80af9743b563fb426460575f3e624a7d.svg";
export { ForwardRef as ReactComponent };